import {extend} from 'flarum/common/extend';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import UserControls from 'flarum/forum/utils/UserControls';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';
import ActorAuditModal from './components/ActorAuditModal';
import DiscussionAuditModal from './components/DiscussionAuditModal';
import UserAuditModal from './components/UserAuditModal';
import AuditModal from './components/AuditModal';
import AuditLog from '../common/models/AuditLog';

app.initializers.add('kilowhat-audit', () => {
    app.store.models['kilowhat-audit'] = AuditLog;

    extend(DiscussionControls, 'moderationControls', function (items, discussion) {
        if (!app.forum.attribute('canAuditDiscussion')) {
            return;
        }

        items.add('kilowhat-audit-user', Button.component({
            icon: 'fas fa-book',
            onclick() {
                app.modal.show(DiscussionAuditModal, {
                    discussion,
                });
            },
        }, app.translator.trans('kilowhat-audit.forum.link.discussion-audit')));
    });

    extend(UserControls, 'moderationControls', function (items, user) {
        if (!app.forum.attribute('canAuditUser')) {
            return;
        }

        items.add('kilowhat-audit-user', Button.component({
            icon: 'fas fa-book',
            onclick() {
                app.modal.show(UserAuditModal, {
                    user,
                });
            },
        }, app.translator.trans('kilowhat-audit.forum.link.user-audit')));
    });

    extend(UserControls, 'moderationControls', function (items, user) {
        if (!app.forum.attribute('canAudit')) {
            return;
        }

        items.add('kilowhat-audit-actor', Button.component({
            icon: 'fas fa-book',
            onclick() {
                app.modal.show(ActorAuditModal, {
                    user,
                });
            },
        }, app.translator.trans('kilowhat-audit.forum.link.actor-audit')));
    });

    extend(SessionDropdown.prototype, 'items', function (items) {
        if (!app.forum.attribute('canAudit')) {
            return;
        }

        items.add('kilowhat-audit', Button.component({
            icon: 'fas fa-book',
            onclick() {
                app.modal.show(AuditModal);
            },
        }, app.translator.trans('kilowhat-audit.forum.link.all-audit')), 20); // Value above zero,so it doesn't end up below the admin link
    });
});
